import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerInlineDirective } from 'ngx-bootstrap/datepicker';

@Component({
    selector: 'app-mobile-date-picker',
    templateUrl: './mobile-date-picker.component.html',
    styleUrls: ['./mobile-date-picker.component.scss'],
    imports: [BsDatepickerInlineDirective],
    standalone: true
})
export class MobileDatePickerComponent implements OnInit {

  @Input() title;
  @Input() bsConfig;
  @Input() bsValue;
  @Input() minDate;
  @Output() bsValueChange = new EventEmitter;
  @Output() modalDismiss = new EventEmitter;
  @ViewChild('template', { static: true }) template;

  public firstTimeLoadedDatePicker = true;

  public modalRef: BsModalRef;


  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
    this.show();
  }

  show() {
    const modalConfig = {
      keyboard: false,
      ignoreBackdropClick: false,
      class: 'mobile-datepicker'
    };
    this.modalRef = this.modalService.show(this.template, { ...modalConfig });
    const modalCallback =  this.modalService.onHide.subscribe(() => {
      this.modalDismiss.emit(true);
      modalCallback.unsubscribe();
    });
  }

  selectDate(evt) {
    if (!this.firstTimeLoadedDatePicker) {
      this.bsValueChange.emit(evt);
      this.modalRef.hide();
      this.firstTimeLoadedDatePicker = true;
    }
    this.firstTimeLoadedDatePicker = false;
  }

}
